<template>
    <table class="table table-bordered table-vcenter">
        <thead>
            <tr>
                <th>Width</th>
                <th>Height</th>
                <th class="text-center">
                    <button type="button" class="btn btn-sm btn-secondary" @click="addRow">
                        <i class="fa fa-plus"></i>
                    </button>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(dimension, index) in dimensions" :key="index">
                <td>
                    <input
                        v-model.number="dimension.width"
                        :name="`dimensions[${index}][width]`"
                        class="form-control"
                        min="1"
                        type="number"
                        required
                    >
                </td>
                <td>
                    <input
                        v-model.number="dimension.height"
                        :name="`dimensions[${index}][height]`"
                        class="form-control"
                        min="1"
                        type="number"
                        required
                    >
                </td>
                <td class="text-center">
                    <button type="button" class="btn btn-sm btn-alt-danger" @click="removeRow(index)">
                        <i class="fa fa-fw fa-trash"></i>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        initialDimensions: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            dimensions: [],
        };
    },

    mounted() {
        this.dimensions = this.initialDimensions.map((dimension) => ({
            width: Number(dimension.width),
            height: Number(dimension.height),
        }));
    },

    methods: {
        addRow() {
            this.dimensions.push({
                width: '',
                height: '',
            });
        },

        removeRow(index) {
            this.dimensions.splice(index, 1);
        },
    },
};
</script>
